"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByScore = exports.sortByCategory = exports.sortFormattedSuggestions = void 0;
/**
 * Sorts the suggestion array according to the config (either by category
 * or score)
 * @param config Config
 * @param suggestions FormattedSuggestion[]
 * @returns FormattedSuggestion[]
 */
function sortFormattedSuggestions(config, suggestions) {
    if (config.params.group_suggestions_by_category) {
        return sortByCategory(config, suggestions);
    }
    else {
        return sortByScore(suggestions);
    }
}
exports.sortFormattedSuggestions = sortFormattedSuggestions;
/**
 * Sorts the suggestion array according to the order in which typeahead categories are
 * defined in the search_widget config
 * @param config Config
 * @param suggestions FormattedSuggestion[]
 * @returns FormattedSuggestion[]
 */
function sortByCategory(config, suggestions) {
    const sortHash = {};
    config.params.typeahead_categories.forEach((category, index) => {
        sortHash[category.category] = index;
    });
    suggestions.sort((a, b) => {
        var _a, _b;
        const priorityForA = (_a = sortHash[a.category]) !== null && _a !== void 0 ? _a : 1;
        const priorityForB = (_b = sortHash[b.category]) !== null && _b !== void 0 ? _b : 1;
        return priorityForA - priorityForB;
    });
    return suggestions;
}
exports.sortByCategory = sortByCategory;
/**
 * Sorts the suggestion array according to the suggestions' score
 * @param suggestions FormattedSuggestion[]
 * @returns FormattedSuggestion[]
 */
function sortByScore(suggestions) {
    return suggestions.sort((a, b) => b.score - a.score);
}
exports.sortByScore = sortByScore;
//# sourceMappingURL=sortFormattedSuggestions.js.map